import FormatItem from '@/assets/formats/format-item'

import TaishokutodokeEdit from '@/components/formats/TaishokutodokeEdit'
import TaishokutodokeSample from '@/assets/formats/sample/taishokutodoke-sample'
import TaishokutodokePreview from '@/components/formats/TaishokutodokePreview'
import TaishokutodokeCards from '@/assets/formats/taishokutodoke-cards'

import EntrySheetEdit from '@/components/formats/EntrySheetEdit'
import EntrySheetPreview from '@/components/formats/EntrySheetPreview'
import EntrySheetCards from '@/assets/formats/EntrySheet-cards'

import LetterEdit from '@/components/formats/LetterEdit'
import LetterSample from '@/assets/formats/sample/letter-sample'
import LetterPreview from '@/components/formats/LetterPreview'
import LetterCards from '@/assets/formats/letter-cards'

import ShibouDoukishoEdit from '@/components/formats/ShibouDoukishoEdit'
import ShibouDoukishoPreview from '@/components/formats/ShibouDoukishoPreview'
import ShibouDoukishoCards from '@/assets/formats/shiboudoukisho-cards'

import AtenaEdit from '@/components/formats/AtenaEdit'
import AtenaPreview from '@/components/formats/AtenaPreview'
import AtenaCards from '@/assets/formats/atena-cards'

const formatsIndex = [
  new FormatItem({
    id: 'taishokutodoke',
    title: '退職願・退職届',
    description:
      '基本的な退職願・退職届のテンプレートです。少ない入力で簡単に作成できます。',
    thumbnail: '/static/img/formats/sample/yagish_taishokutodoke_img.jpeg',
    images: ['/static/img/formats/sample/yagish_taishokutodoke_img.jpeg'],
    newdetail1: 'A4サイズ推奨',
    newdetail2: '',
    newdetail3: '',
    newdetail: '',
    requiredBasicFields: ['name', 'birth', 'address', 'tel', 'email'],
    hashs: ['退職届'],
    components: {
      edit: TaishokutodokeEdit,
      preview: TaishokutodokePreview
    },
    formatDataType: 'taishokutodoke',
    cards: TaishokutodokeCards,
    sampleData: TaishokutodokeSample,
    exampleSentences: {
      intro: [
        {
          type: 'others',
          name: '一般的なあいさつ',
          sentences:
            '拝啓\u3000貴社におかれましてはますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '一般的なあいさつ',
          sentences: '拝啓\u3000貴社ますますご清栄のこととお慶び申し上げます'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000初春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000新春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000厳冬の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000立春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000早春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000残寒の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000春分の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000春陽の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000浅春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000春暖の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000陽春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000仲春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000新緑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000薫風の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000立夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000小夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000入梅の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000梅雨の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000盛夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000仲夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000猛暑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000残暑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000晩夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000立秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000初秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000新秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000秋冷の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000仲秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000秋涼の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000秋晴の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000晩秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000向寒の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000菊花の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000師走の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000初冬の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000寒冷の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        }
      ],
      entry: [
        {
          type: 'others',
          name: '一般的な応募経緯',
          sentences:
            'この度、貴社の○○職に応募させて頂きたく、下記の応募書類を送付させて頂きます。\nぜひご検討頂き、面接の機会を頂けますと幸いに存じます。何卒宜しくお願い申し上げます。'
        },
        {
          type: 'others',
          name: '詳細に経緯を説明',
          sentences:
            'この度、〇〇に掲載されておりました、〇〇職の求人に応募させていただきます。\n\n私は３年間にわたり海外営業として勤務しており、国内勤務をしながら海外の顧客を担当してまいりました。これまでの経験を活かして貴社の〇〇業務に貢献したいと考え、応募させていただきました。\n\nご検討の上、是非ともご面談の機会をいただけますと幸いです。\n\nご査収のほど、宜しくお願い申し上げます。'
        }
      ],
      resume: [
        { type: 'others', name: '', sentences: 'はじめての転職大学卒業。' },
        { type: 'others', name: '', sentences: '2社の転職を経験大学を卒業。' },
        { type: 'others', name: '', sentences: '複数の転職を経験大学を卒業。' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'entrysheet',
    title: 'エントリーシート',
    description:
      '基本的なエントリーシートのテンプレートです。志望先の企業に選考を受ける意思を明確にし、かつ自分の経歴やスキル、人柄などについてアピールするための書類になります。',
    thumbnail: '/static/img/formats/sample/entrysheet_img.png',
    images: ['/static/img/formats/sample/entrysheet_img.png'],
    newdetail1: 'A4サイズ推奨',
    newdetail2: '',
    newdetail3: '',
    newdetail: '',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'address',
      'tel',
      'email',
      'photo'
    ],
    hashs: ['エントリーシート'],
    components: {
      edit: EntrySheetEdit,
      preview: EntrySheetPreview
    },
    cards: EntrySheetCards,
    formatDataType: 'rirekisho'
    // sampleData: EntrySheetSample,
  }),
  new FormatItem({
    id: 'shiboudoukisho',
    title: '志望動機書',
    description:
      '履歴書以外に志望動機を求められた際に作成するテンプレートです。',
    thumbnail: '/static/img/formats/sample/shiboudoukisho.jpg',
    images: ['/static/img/formats/sample/shiboudoukisho.jpg'],
    newdetail1: 'A4サイズ推奨',
    newdetail2: '',
    newdetail3: '',
    newdetail: '',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'address',
      'tel',
      'email',
      'photo'
    ],
    hashs: ['志望動機書'],
    components: {
      edit: ShibouDoukishoEdit,
      preview: ShibouDoukishoPreview
    },
    cards: ShibouDoukishoCards,
    formatDataType: 'ShibouDoukisho'
    // sampleData: EntrySheetSample,
  }),
  new FormatItem({
    id: 'atena',
    title: '宛名を印刷する',
    description: '郵送の際、封筒に宛名を印刷するためのテンプレートです。',
    thumbnail: '/static/img/formats/sample/atena.png',
    images: ['/static/img/formats/sample/atena.png'],
    newdetail1: 'L版シール紙、A4普通紙',
    newdetail2: '',
    newdetail3: '',
    newdetail: '',
    requiredBasicFields: ['name', 'address'],
    hashs: ['宛名を印刷する'],
    components: {
      edit: AtenaEdit,
      preview: AtenaPreview
    },
    cards: AtenaCards,
    formatDataType: 'Atena'
  }),
  new FormatItem({
    id: 'letter',
    title: '送付状',
    description:
      '豊富な例文やサンプル、フォーマットを用意しています。PCやスマホにも対応。',
    // description: 'A4サイズの送付状テンプレートです。送付状を入れておくことで、丁寧な印象を与えることができます。面接官の印象がガラッと変わるので、1枚入れておくことをオススメします。',
    thumbnail: '/static/img/formats/sample/yagish_letter_img.jpeg',
    images: ['/static/img/formats/sample/yagish_letter_img.jpeg'],
    newdetail1: 'A4サイズ推奨',
    newdetail2: '',
    newdetail3: '全36種類のあいさつ季語を例文から選べます',
    newdetail: '',
    requiredBasicFields: ['name', 'address', 'tel', 'email'],
    hashs: ['送付状'],
    components: {
      edit: LetterEdit,
      preview: LetterPreview
    },
    cards: LetterCards,
    sampleData: LetterSample,
    formatDataType: 'letter',
    exampleSentences: {
      intro: [
        {
          type: 'others',
          name: '一般的なあいさつ',
          sentences:
            '拝啓\u3000貴社におかれましてはますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '一般的なあいさつ',
          sentences: '拝啓\u3000貴社ますますご清栄のこととお慶び申し上げます'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000初春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000新春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000厳冬の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000立春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000早春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000残寒の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000春分の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000春陽の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000浅春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000春暖の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000陽春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000仲春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000新緑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000薫風の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000立夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000小夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000入梅の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000梅雨の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000盛夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000仲夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000猛暑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000残暑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000晩夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000立秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000初秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000新秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000秋冷の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000仲秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000秋涼の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000秋晴の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000晩秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000向寒の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000菊花の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000師走の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000初冬の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000寒冷の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        }
      ],
      entry: [
        {
          type: 'others',
          name: '一般的な応募経緯',
          sentences:
            'この度、貴社の○○職に応募させて頂きたく、下記の応募書類を送付させて頂きます。\nぜひご検討頂き、面接の機会を頂けますと幸いに存じます。何卒宜しくお願い申し上げます。'
        },
        {
          type: 'others',
          name: '詳細に経緯を説明',
          sentences:
            'この度、〇〇に掲載されておりました、〇〇職の求人に応募させていただきます。\n\n私は３年間にわたり海外営業として勤務しており、国内勤務をしながら海外の顧客を担当してまいりました。これまでの経験を活かして貴社の〇〇業務に貢献したいと考え、応募させていただきました。\n\nご検討の上、是非ともご面談の機会をいただけますと幸いです。\n\nご査収のほど、宜しくお願い申し上げます。'
        }
      ],
      resume: [
        { type: 'others', name: '', sentences: 'はじめての転職大学卒業。' },
        { type: 'others', name: '', sentences: '2社の転職を経験大学を卒業。' },
        { type: 'others', name: '', sentences: '複数の転職を経験大学を卒業。' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  })
]

export default formatsIndex
